import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SharedComponentsModule} from '../../../../../bonding_shared/components/shared-components.module';
import {CompanySharedModule} from '../company-shared.module';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {CompanyCreditInsuranceExposureComponent} from './company-credit-insurance-exposure.component';
import {CompanyCurrentExposureCiComponent} from './company-current-exposure-ci.component';
import {CompanyCurrentExposureComponent} from './company-current-exposure.component';
import {CompanyPotentialExposureCiComponent} from './company-potential-exposure-ci.component';
import {CompanyPotentialExposureComponent} from './company-potential-exposure.component';
import {CompanySuretyExposureComponent} from './company-surety-exposure.component';
import {CompanyTotalLiabilityExposureComponent} from './company-total-liability-exposure.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    CompanySharedModule,
    BsDropdownModule,
  ],
  exports: [
    CompanyCreditInsuranceExposureComponent,
    CompanyCurrentExposureCiComponent,
    CompanyCurrentExposureComponent,
    CompanyPotentialExposureCiComponent,
    CompanyPotentialExposureComponent,
    CompanySuretyExposureComponent,
    CompanyTotalLiabilityExposureComponent,
  ],
  declarations: [
    CompanyCreditInsuranceExposureComponent,
    CompanyCurrentExposureCiComponent,
    CompanyCurrentExposureComponent,
    CompanyPotentialExposureCiComponent,
    CompanyPotentialExposureComponent,
    CompanySuretyExposureComponent,
    CompanyTotalLiabilityExposureComponent,
  ],
})
export class CompanyExposureModule {}
